.uic-switch {
  box-sizing: border-box;
  /**
        @prop --uic-switch-background: the default background
        @prop --uic-switch-background-active: the background in active state
        @prop --uic-switch-background-checked: the background in checked state
        @prop --uic-switch-background-disabled: the background in disabled state

        @prop --uic-switch-border: the default border
        @prop --uic-switch-border-checked: the border in checked state
        @prop --uic-switch-border-disabled: the border in disabled state
        @prop --uic-switch-border-focus: the border in focus state

        @prop --uic-switch-thumb-width: the width of the thumb
        @prop --uic-switch-thumb-height: the height of the thumb

        @prop --uic-switch-track-width: the width of the track where the thumb moves
    */

  display: inline-block;

  &__label {
    display: block;
    padding: 12px 8px;
  }

  &__label-slot {
    @include font(normal);
    @include truncate();
    color: var(--uic-color-black);
  }

  &__input {
    height: 0;
    opacity: 0;
    position: absolute;
    width: 0;
  }

  &__track {
    cursor: pointer;
    position: relative;
    width: var(--uic-switch-track-width);

    &::before {
      background: var(--uic-color-grey2);
      content: '';
      height: 2px;
      position: absolute;
      top: 50%;
      width: 100%;
    }
  }

  &__thumb {
    background: var(--uic-color-white);
    height: var(--uic-switch-thumb-height);
    position: relative;
    transition: transform 0.3s ease-out;
    width: var(--uic-switch-thumb-width);

    &::before {
      @include absolute();
      background: var(--uic-switch-background);
      border: var(--uic-switch-border);
      box-shadow: 0 2px 4px 0 var(--uic-atom-shadow-color-primary), 0 2px 8px 0 var(--uic-atom-shadow-color-secondary);
      content: '';
    }

    &:hover::before {
      border: var(--uic-switch-border-hover);
    }
  }

  &--checked {
    .uic-switch__thumb {
      transform: translateX(calc(var(--uic-switch-track-width) - var(--uic-switch-thumb-width)));

      &::before {
        background: var(--uic-switch-background-checked);
        border: var(--uic-switch-border-checked);
        box-shadow: 0 2px 8px 0 var(--uic-color-blue2a25);
      }
    }
  }

  &--disabled {
    .uic-switch__thumb::before {
      background: var(--uic-switch-background-disabled);
      border: var(--uic-switch-border-disabled);
      box-shadow: none;
    }
  }

  &--has-label {
    .uic-switch__label {
      padding: 2px 8px 8px;
    }

    .uic-switch__label-slot {
      padding-bottom: 4px;
    }
  }

  &__input:active + &__track &__thumb::before,
  &__label:active &__thumb::before {
    background: var(--uic-switch-background-active);
    box-shadow: none;
  }

  &__input:focus + &__track &__thumb::before {
    border: var(--uic-switch-border-focus);
  }
}
